import { EducationLevel } from 'services/api/types';

/**
 * Formats subject name with education level
 * @example "Математика 5-9 класс"
 */
export const formatSubjectWithLevel = (name: string, educationLevel: EducationLevel): string => {
  const educationLevelMapper = {
    [EducationLevel.Noo]: '1-4 класс',
    [EducationLevel.Ooo]: '5-9 класс',
    [EducationLevel.Soo]: '10-11 класс',
  };

  return `${name} ${educationLevelMapper[educationLevel]}`;
};
